function account(state = [], action) {
    switch (action.type) {
      case 'ACCOUNT':
        return [...state, ...action.payload]
      default:
        return state
    }
  }

export default account